/* AWA saved items (CLAUDE DRAFT). Kept in this browser only (localStorage). */
(function () {
  var KEY = 'awa_wishlist_v1', SENT = 'awa_wishlist_sent';
  var root, panel, lastFocus;
  function load() { try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function save(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} update(); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function fromBtn(b) { var d = b.dataset; return { id: d.wlId, title: d.wlTitle, url: d.wlUrl, img: d.wlImg || '', price: d.wlPrice || '', vendor: d.wlVendor || '', sku: d.wlSku || '' }; }

  function toggle(b) {
    var item = fromBtn(b), list = load(), i = list.findIndex(function (x) { return String(x.id) === String(item.id); });
    if (i > -1) list.splice(i, 1); else list.unshift(item);
    save(list);
    b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
    var hb = document.querySelector('.awa-wl-header'); if (hb && i === -1) { hb.classList.remove('is-pop'); void hb.offsetWidth; hb.classList.add('is-pop'); }
  }
  function hearts(scope) {
    var ids = load().map(function (x) { return String(x.id); });
    (scope || document).querySelectorAll('.awa-wl-heart').forEach(function (b) {
      var on = ids.indexOf(String(b.dataset.wlId)) > -1;
      if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = (on ? 'Remove ' : 'Save ') + (b.dataset.wlTitle || 'product');
      if (b.getAttribute('aria-label') !== lbl) b.setAttribute('aria-label', lbl);
    });
  }
  function update() {
    var list = load(), n = list.length;
    hearts();
    document.querySelectorAll('[data-wl-badge]').forEach(function (c) { c.textContent = n; c.hidden = n === 0; });
    if (!root) return;
    root.querySelector('[data-wl-count-text]').textContent = n + (n === 1 ? ' item' : ' items');
    root.querySelector('[data-wl-empty]').hidden = n > 0;
    root.querySelector('[data-wl-quote]').hidden = n === 0;
    var ul = root.querySelector('[data-wl-list]'); ul.textContent = '';
    list.forEach(function (x) {
      var li = el('li', 'awa-wl__item');
      var a = el('a', 'awa-wl__img'); a.href = x.url;
      if (x.img) { var im = el('img'); im.src = x.img; im.alt = ''; im.loading = 'lazy'; a.appendChild(im); }
      var info = el('div', 'awa-wl__info');
      if (x.vendor) info.appendChild(el('span', 'awa-wl__vendor', x.vendor));
      var t = el('a', 'awa-wl__name', x.title); t.href = x.url; info.appendChild(t);
      if (x.price) info.appendChild(el('span', 'awa-wl__price', x.price));
      var rm = el('button', 'awa-wl__rm'); rm.type = 'button'; rm.setAttribute('aria-label', 'Remove ' + x.title); rm.innerHTML = '&times;';
      rm.addEventListener('click', function () { save(load().filter(function (y) { return String(y.id) !== String(x.id); })); });
      li.appendChild(a); li.appendChild(info); li.appendChild(rm); ul.appendChild(li);
    });
  }
  function open() {
    if (!root) return; lastFocus = document.activeElement;
    root.hidden = false; requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden'; panel.focus();
  }
  function close() {
    if (!root) return; root.classList.remove('is-open'); document.documentElement.style.overflow = '';
    setTimeout(function () { root.hidden = true; }, 260); if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function headerButton() {
    // Put a heart next to the cart icon, borrowing the cart icon's own classes so it matches.
    if (document.querySelector('.awa-wl-header')) return;
    var cart = document.querySelector('awa-header a[href$="/cart"], awa-header a[href*="/cart"], header a[href$="/cart"]');
    if (!cart) return;
    var b = el('button', (cart.className || '') + ' awa-wl-header'); b.type = 'button'; b.setAttribute('aria-label', 'Saved items');
    b.innerHTML = '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true"><path d="M12 20.7s-7.5-4.6-9.6-9.2C.9 8 2.9 4.2 6.6 4.2c2.2 0 3.6 1.3 5.4 3.2 1.8-1.9 3.2-3.2 5.4-3.2 3.7 0 5.7 3.8 4.2 7.3-2.1 4.6-9.6 9.2-9.6 9.2z"/></svg>';
    var src = cart.querySelector('.awa-header__count'), badge = el('span', (src ? src.className.replace('is-empty', '') : '') + ' awa-wl-badge'); badge.setAttribute('data-wl-badge', ''); b.appendChild(badge);
    b.addEventListener('click', open);
    cart.parentNode.insertBefore(b, cart);
  }
  function liftOverQuickView() {
    var q = document.querySelector('.product-featured-image quick-view, .product-card-quickview');
    if (!q) return;
    var h = q.offsetHeight || 0;
    if (h > 0 && h < 120) document.documentElement.style.setProperty('--awa-wl-lift', (h + 12) + 'px');
  }
  function init() {
    root = document.querySelector('[data-awa-wl]');
    if (root) {
      document.body.appendChild(root); panel = root.querySelector('.awa-wl__panel');
      root.querySelectorAll('[data-wl-close]').forEach(function (c) { c.addEventListener('click', close); });
      var f = root.querySelector('[data-wl-form]');
      if (f) f.addEventListener('submit', function () {
        var lines = load().map(function (x, i) { return (i + 1) + '. ' + x.title + (x.sku ? ' (' + x.sku + ')' : '') + (x.price ? ' – ' + x.price : '') + ' – ' + location.origin + x.url; });
        f.querySelector('[data-wl-items-field]').value = lines.join('\n');
        try { sessionStorage.setItem(SENT, '1'); } catch (e) {}
      });
    }
    headerButton(); update();
    document.addEventListener('mouseover', function once(e) { if (e.target.closest && e.target.closest('.product-card')) { setTimeout(liftOverQuickView, 300); document.removeEventListener('mouseover', once); } });
    try { if (sessionStorage.getItem(SENT) && /[?&]contact_posted=true/.test(location.search)) { sessionStorage.removeItem(SENT); root.querySelector('[data-wl-sent]').hidden = false; if (!window.AWAThanks) open(); } } catch (e) {}
  }
  document.addEventListener('click', function (e) { var b = e.target.closest('.awa-wl-heart'); if (b) { e.preventDefault(); e.stopPropagation(); toggle(b); } }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root && !root.hidden) close(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) update(); });
  document.addEventListener('shopify:section:load', update);
  // Cards added later (filters, infinite scroll, recommendations) get the right heart state too.
  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) for (var k = 0; k < m[i].addedNodes.length; k++) {
      var n = m[i].addedNodes[k];
      if (n.nodeType === 1 && !n.closest('[data-awa-wl]') && (n.matches('.awa-wl-heart') || n.querySelector('.awa-wl-heart'))) { hearts(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.AWAWishlist = { open: open, close: close, list: load };
})();